import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const AudioTabActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid ${COLORS.borderColor};
  padding-bottom: 16px;
  margin-top: 20px;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding-bottom: 20px;
  }
`
